export function getMp4Url(videoData) {
  var _videoData$resolution, _videoData$resolution2;
  return (_videoData$resolution = videoData.resolutions) != null && _videoData$resolution.length ? ((_videoData$resolution2 = videoData.resolutions.sort((a, b) => {
    return ((b == null ? void 0 : b.width) || 0) - ((a == null ? void 0 : a.width) || 0);
  })[0]) == null ? void 0 : _videoData$resolution2.url) || "" : "";
}
//# sourceMappingURL=utils.js.map